import axios from 'axios';
import { BASE_URL } from '../../constants/api';

type RefreshTokenPayload = {
    jwt: string;
    refreshToken: string;
    deviceId: string;
    clientId: string;
};

type RefreshTokenResponse = {
    accessToken: string;
    refreshToken: string;
};

export const refreshToken = async ({
    jwt,
    refreshToken,
    deviceId,
}: RefreshTokenPayload) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/auth/refresh-token`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'rf-token': `Bearer ${refreshToken}`,
                    'device-id': deviceId,
                    Authorization: `Bearer ${jwt}`,
                },
            }
        );
        return response.data as RefreshTokenResponse;
    } catch (error) {
        console.error('refreshToken error: ', { error });
        return null;
    }
};
